import { useState } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Sidebar } from "./Sidebar";
import { Breadcrumb } from "~/components/ui/Breadcrumb";

interface MainLayoutProps {
  children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const openSidebar = () => setIsSidebarOpen(true);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <div className="flex flex-col min-h-screen">
      {/* Sidebar for mobile navigation */}
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />

      {/* Header */}
      <Header onOpenSidebar={openSidebar} />

      {/* Mobile sidebar toggle button - improved positioning and touch target */}
      <div className="md:hidden fixed bottom-6 right-6 z-10">
        <button
          onClick={openSidebar}
          className="bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 active:bg-blue-800 transition-colors duration-200 touch-manipulation min-w-[56px] min-h-[56px] flex items-center justify-center"
          aria-label="메뉴 열기"
        >
          <svg
            className="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>

      {/* Main content */}
      <main className="flex-grow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 mb-16">
          {/* Breadcrumb navigation */}
          {/* <Breadcrumb className="mb-4" /> */}
          {children}
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
